import { RouterService } from './../../../../services/router/router.service';
import { AlertService } from './../../../../services/alert/alert.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { LanguagesService } from './../../../../services/languagesService/languages.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-delete-account-confirmation',
  templateUrl: './delete-account-confirmation.page.html',
  styleUrls: ['./delete-account-confirmation.page.scss'],
})
export class DeleteAccountConfirmationPage implements OnInit {
LoginConfirmed = false;
  constructor(
    public languageService: LanguagesService,  private auth : AuthService, private alertService : AlertService, private router : RouterService ) { }

  ngOnInit() {
  }

  deleteAccountConf(){
    if(this.LoginConfirmed){
      this.alertService.presentAlertWithMessage({header:this.getTextIUDeleteConfirmation.AlertDeleteConfirmationHead,description:this.getTextIUDeleteConfirmation.AlertDeleteConfirmationMsg},[this.getTextIUDeleteConfirmation.AlertDeleteConfirmationBtn])
      .then(()=>{
         this.auth.unsubscribeUserFromGnx().then((res:any)=>{
          if (res.updated) {
            this.auth.logout();
          }
        }) 
      })
    }
  }
  setConfirmacion($event){
    this.LoginConfirmed = $event.isLoginConfirmation 
  }

  cancel(){
    this.router.navigate("app/home")

  }

  get getTextIUDeleteConfirmation() {
    return this.languageService.textsIU.page_deleteAccountConfirmation;
  }
}
